var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleExclamation = function SvgCircleExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 9.167a10.834 10.834 0 1 1 0 21.668 10.834 10.834 0 0 1 0-21.668m0 24.167a13.333 13.333 0 1 0 0-26.666 13.333 13.333 0 0 0 0 26.666m0-20c-.693 0-1.25.557-1.25 1.25v5.833c0 .693.557 1.25 1.25 1.25.692 0 1.25-.557 1.25-1.25v-5.833c0-.693-.558-1.25-1.25-1.25M21.665 25a1.667 1.667 0 1 0-3.334 0 1.667 1.667 0 0 0 3.334 0"
  })));
};
export default SvgCircleExclamation;